import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

const postwriteImageInStorage = async (payload: IPostwriteImageInStorage) => {
  const response = await request.post(
    `api/v2/store/advertisement-image`,
    getFormData(
      payload as unknown as {
        [name: string]: string | Blob;
      },
    ),
  );
  return response.data;
};

export default postwriteImageInStorage;
